import {SlideType} from '../../../../../../graphql/generated/types';
import {ViewerType} from '../constant/viewerConstant';
import {slideTypeToViewerType} from '../type/slideTypeToViewerType';
import {ImageViewerSettingContainer} from './ImageViewerSettingContainer';
import {TalkViewerSettingContainer} from './TalkViewerSettingContainer';
import {TextViewerSettingContainer} from './TextViewerSettingContainer';

export interface ViewerSettingContainerProps {
  seriesId: number;
  productId: number;
  slideType: SlideType;
}

export function ViewerSettingContainer({
  seriesId,
  productId,
  slideType,
}: ViewerSettingContainerProps) {
  const viewerType = slideTypeToViewerType(slideType || SlideType.None);
  switch (viewerType) {
    case ViewerType.TextViewer:
      return <TextViewerSettingContainer productId={productId} />;
    case ViewerType.ImageViewer:
      return <ImageViewerSettingContainer productId={productId} />;
    case ViewerType.TalkViewer:
      return (
        <TalkViewerSettingContainer seriesId={seriesId} productId={productId} />
      );
    default:
      return null;
  }
}
